var render = function render(){var _vm=this,_c=_vm._self._c;return _c('notification',{attrs:{"type":_vm.variant,"icon":_vm.getVariantIcon,"title":_vm.getVariantTitle,"classes":"custom-toast"}},[(_vm.message)?_c('p',[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }